// extracted by mini-css-extract-plugin
module.exports = {"modalFrame":"styles_modalFrame__GkyqQ","iconWrapper":"styles_iconWrapper___d44k","modalFrameWrapper":"styles_modalFrameWrapper__MtOc4","tall":"styles_tall__EvNXK"};